var App = App || {};

App.Register = (function ($) {
	"use strict";


	function init() {
		$(document).on("submit", "form.register-async", function (e) {
			e.preventDefault();

			const $form = $(this);
			const $summary = $form.find(".form-validation-message").empty();
			const $pwd = $form.find("#register-password");
			const $confirm = $form.find("#register-password-confirm");
			const $submitButton = $form.find('button[type="submit"]');

			$form.find("input").each((_, el) => el.setCustomValidity(""));

			if ($pwd.val() && $confirm.val() && $pwd.val() !== $confirm.val()) {
				$confirm[0].setCustomValidity("Passwords do not match.");
			}

			if ($form[0].checkValidity()) {
				const formData = Object.fromEntries($form.serializeArray().map(({ name, value }) => [name, value]));
				App.Spinner.startSpinner($submitButton, "Processing");
				$.ajax({
					type: $form.attr("method") || "POST",
					url: $form.attr("action"),
					data: JSON.stringify(formData),
					contentType: 'application/json; charset=utf-8'
				}).done(function (response, textStatus, jqXHR) {
					if (!response) {
						$summary.text("Unable to complete registration. Try again later");
						return;
					};

					if (!response.success) {
						$summary.text(response?.message || "Unable to complete registration. Try again later.");
					}

					if (response.success && response.data) {
						let identityResponse = response.data;

						if (!identityResponse.succeeded) {
							let error = identityResponse.errors[0] || {},
								errorCode = error?.code || "",
								errorDescription = error?.description || "";

							switch (errorCode) {
								case "DuplicateEmail":
									$form.find("#register-email")[0].setCustomValidity(errorDescription);
									break;
								case "DuplicateUserName":
									$form.find("#register-username")[0].setCustomValidity(errorDescription);
									break;
								case "PasswordTooShort":
									$pwd[0].setCustomValidity(errorDescription);
									break;
								default:
									$summary.text(identityResponse.errors[0]?.description || "Unable to complete registration. Try again later.");
							}
							$form[0].checkValidity();
							applyValidationMessages($form);
							$form.addClass("was-validated");
							focusFirstInvalid($form);
						}
						else {
							$summary.text("Registration successful!");
							setTimeout(() => location.reload(), 1000);
						}
					}
				}).fail(function (jqXHR) {
					$summary.text("Unable to complete registration. Try again later");
				}).always(function () {
					App.Spinner.stopSpinner($submitButton);
				});
			} else {
				applyValidationMessages($form);
				focusFirstInvalid($form);
			}

			$form.addClass("was-validated");
		});
	}

	function focusFirstInvalid($form) {
		const $first = $form.find(":invalid").first();
		if ($first.length) requestAnimationFrame(() => $first.trigger("focus"));
	}
	function applyValidationMessages($form) {
		$form.find(":invalid").each(function () {
			let msg = "";

			switch (true) {
				case this.validity.valueMissing:
					msg = $(this).data("val-required") || "A value is required.";
					break;
				case this.validity.typeMismatch:
					msg = $(this).data("val-type") || "Incorrect format.";
					break;
				default:
					msg = this.validationMessage || "";
					break;
			}

			$(this).siblings(".field-validation-error").text(msg);
		});
	}

	return {
		init: init
	};

})(jQuery);

$(function () {
	App.Register.init();
});